import { RequestHandler } from 'express';

import { saveRecorded } from '~/app/mockingMiddleware';

import ProjectsService from '~/services/ProjectsService';
import mapAppErrorToObject from '~/transformations/mapAppErrorToObject';

export const getProjects: RequestHandler = async (req, res, next) => {
  try {
    const service = new ProjectsService(res.locals.payload, res.locals.preview);

    await service.GetSourceProjects();
    await service.GetTargetProjects();
    res.locals.service = service;
    next();
  } catch (error: any) {
    res.status(500).send({ error: mapAppErrorToObject(error) });
  }
};

export const returnProjects: RequestHandler = (req, res) => {
  try {
    const { id, service }: { id?: string; service?: ProjectsService } =
      res.locals;

    const projectIds = id ? [id] : undefined;

    const response = service?.MapGetProjectsResponse(projectIds);

    res.send(response);

    saveRecorded(req, res, {
      operation: 'returnProjects',
      response,
    });
  } catch (ex: any) {
    res.status(500).send({ error: mapAppErrorToObject(ex) });
  }
};

export const getApiKeys: RequestHandler = async (req, res) => {
  try {
    const service = new ProjectsService(res.locals.payload, res.locals.preview);

    await service.GetApiKeys();
    const response = service.MapGetApiKeysResponse();

    res.send(response);
    saveRecorded(req, res, {
      operation: 'getApiKeys',
      response,
    });
  } catch (error: any) {
    res.status(500).send({ error: mapAppErrorToObject(error) });
  }
};
